import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminPage from '../../../Components/AdminPage.js';
import { royaltyQueries } from '../../../graphql/queries';
import {
  getDateFilterOptionsByQuarter,
  getCurrencyDropdownConfig
} from '../../../helpers/admin.js';

const AuthorPurchases = ({ currencies }) => {
  const [currency, setCurrency] = useState('USD');
  const { id } = useParams();
  const dateFilterOptions = getDateFilterOptionsByQuarter();
  const initialDateRange = dateFilterOptions.find(option => option.label === 'Current Quarter');

  const handleCurrencySelection = (currency) => {
    setCurrency(currency.value);
  };

  const columns = [
    { id: 'salesDate', label: 'Date', sortColumn: 'salesDate' },
    { id: 'purchaseItem.product.title', label: 'Product Title', sortColumn: 'purchaseItem.product.title' },
    { id: 'purchaseItem.discount', label: 'Discount Applied (%)', sortColumn: 'purchaseItem.discount' },
    { id: `sales${currency}`, label: `Sales Value (${currency})`, sortColumn: `sales${currency}` }
  ];

  const additionalDropdown = getCurrencyDropdownConfig(currencies, currency, handleCurrencySelection);

  return (
    <AdminPage
      columns={columns}
      query={royaltyQueries.RoyaltyDetails}
      rowsDataPath='royaltyDetails.authorSalesItems'
      countDataPath='royaltyDetails.count'
      showDates
      showSearch={false}
      queryOptions={{ authorId: parseInt(id) }}
      initialOrderBy='salesDate'
      initialOrderByDirection='desc'
      initialDateRange={initialDateRange}
      onRowClick={() => {}}
      dateFilterOptions={dateFilterOptions}
      sectionName='royalties'
      additionalDropdown={additionalDropdown}
    />
  );
};

export default AuthorPurchases;
